import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts/highstock';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.css';
import { getAllUsersAccountsData } from '../services/api';
import Select from '@mui/joy/Select'
import Option from '@mui/joy/Option'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Dashboard = () => {

    const navigate = useNavigate()

    const [showModal, setShowModal] = useState(false);
    const [stopLoss, setStopLoss] = useState('');
    const [takeProfit, setTakeProfit] = useState('');
    const [annotations, setAnnotations] = useState([]);

    const [selectedCurrency, setSelectedCurrency] = useState('');
    const currencySymbols = ['AAPL', 'DJI', 'DXY', 'NDJ']; // Add more currency symbols as needed
    const [showModalCurr, setShowModalCurr] = useState(false);
    const [selectedAccount, setSelectedAccount] = useState('');


    useEffect(() => {

        const fetchData = async () => {
            // Your data fetching logic here...
            const response = await fetch('https://demo-live-data.highcharts.com/aapl-ohlcv.json');
            const data = await response.json();

            const ohlc = [];
            const volume = [];

            for (let i = 0; i < data.length; i += 1) {
                ohlc.push([
                    data[i][0], // the date
                    data[i][1], // open
                    data[i][2], // high
                    data[i][3], // low
                    data[i][4], // close
                ]);

                volume.push([
                    data[i][0], // the date
                    data[i][5], // the volume
                ]);
            }


            Highcharts.stockChart('container', {

                // Existing chart options...
                rangeSelector: {
                    selected: 1,
                },
                title: {
                    text: 'AAPL Stock Price',
                },
                yAxis: [
                    {
                        labels: {
                            align: 'left',
                        },
                        height: '80%',
                        resize: {
                            enabled: true,
                        },
                    },
                    {
                        labels: {
                            align: 'left',
                        },
                        top: '80%',
                        height: '20%',
                        offset: 0,
                    },
                ],
                tooltip: {
                    shape: 'square',
                    headerShape: 'callout',
                    borderWidth: 0,
                    shadow: false,
                    positioner: function (width, height, point) {
                        var chart = this.chart,
                            position;

                        if (point.isHeader) {
                            position = {
                                x: Math.max(
                                    chart.plotLeft,
                                    Math.min(
                                        point.plotX + chart.plotLeft - width / 2,
                                        chart.chartWidth - width - chart.marginRight
                                    )
                                ),
                                y: point.plotY,
                            };
                        } else {
                            position = {
                                x: chart.plotLeft,
                                y: chart.plotTop, // Adjust this if needed
                            };
                        }

                        return position;
                    },
                },

                series: [
                    // Existing series...
                    {
                        type: 'ohlc',
                        id: 'aapl-ohlc',
                        name: 'AAPL Stock Price',
                        data: ohlc,
                    },
                    {
                        type: 'column',
                        id: 'aapl-volume',
                        name: 'AAPL Volume',
                        data: volume,
                        yAxis: 1,
                    },

                    // Annotations for Buy and Sell
                    {
                        type: 'flags',
                        data: annotations,
                        onSeries: 'aapl-ohlc', // Attach to the OHLC series
                        shape: 'circlepin', // You can use different shapes
                        width: 16,
                        fillColor: 'green', // Customize the color
                        style: {
                            color: 'white', // Text color
                        },
                    },
                ],


                // Other existing chart options...
                responsive: {
                    rules: [
                        {
                            condition: {
                                maxWidth: 800,
                            },
                            chartOptions: {
                                rangeSelector: {
                                    inputEnabled: false,
                                },
                            },
                        },
                    ],
                },
            });
        };

        fetchData();

    }, [annotations]);



    const handleTradeClick = () => {
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleSubmit = () => {
        const currentDate = new Date();
        const highchartsDate = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());

        if (stopLoss && takeProfit) {
            const annotation = {
                id: selectedAccount,
                x: highchartsDate,
                title: 'Trade',
                text: `SL: ${stopLoss}, TP: ${takeProfit}`,
            };

            // Load existing annotations for the selected user
            const getAnnotations = localStorage.getItem('annotations')
            const existingAnnotations = (getAnnotations !== null) ? JSON.parse(getAnnotations) : {};
            const userAnnotations = existingAnnotations[selectedAccount] || [];

            // Add the new annotation
            userAnnotations.push(annotation);

            // Update the annotations in local storage
            existingAnnotations[selectedAccount] = userAnnotations;
            localStorage.setItem('annotations', JSON.stringify(existingAnnotations));

            // Update the state with the new annotations
            setAnnotations(userAnnotations);

            setStopLoss('');
            setTakeProfit('');
            setShowModal(false);
        }
    };

    useEffect(() => {
        // Load annotations for the selected user from local storage
        const getAnnotations = localStorage.getItem('annotations')
        const existingAnnotations = (getAnnotations !== null) ? JSON.parse(getAnnotations) : {};
        const userAnnotations = existingAnnotations[selectedAccount] || [];

        // Update the state with the loaded annotations
        setAnnotations(userAnnotations);
    }, [selectedAccount]);

    const addCustomAnnotation = () => {
        const customAnnotation = {
            id: selectedAccount,
            x: Date.UTC(2023, 7, 22), // Replace with your desired date
            title: 'A',
            text: 'annotation.',
        };

        // Load existing annotations for the selected user
        const getAnnotations = localStorage.getItem('annotations')
        const existingAnnotations = (getAnnotations !== null) ? JSON.parse(getAnnotations) : {};
        const userAnnotations = existingAnnotations[selectedAccount] || [];

        // Add the custom annotation
        userAnnotations.push(customAnnotation);
        // // Update the annotations in local storage
        existingAnnotations[selectedAccount] = userAnnotations;
        localStorage.setItem('annotations', JSON.stringify(existingAnnotations));

        // // Update the state with the new annotations
        setAnnotations(userAnnotations);
    };

    const handleCurrencySearch = () => {
        setShowModalCurr(true);
    };

    const handleModalCloseCurr = () => {
        setShowModalCurr(false);
    };

    const handleCurrencySelection = (currency) => {
        setSelectedCurrency(currency);
        setShowModalCurr(false);
    };



    const [accounts, setAccounts] = useState()
    useEffect(() => {


        const fetchUsers = async () => {
            const storedUser = localStorage.getItem('userObj');
            const parsedUser = JSON.parse(storedUser);
            const userAccounts = await getAllUsersAccountsData(parsedUser.data[0].uid)
            setAccounts(userAccounts)
            if (storedUser) {

                setSelectedAccount(userAccounts[0].id);

            }
        }

        fetchUsers()


    }, [])


    const handleChange = (event, newValue) => {
        console.log(newValue)
        setSelectedAccount(newValue)
    };


    return (
        <>
            <div className='px-4 mt-5'>
                <div className='flex flex-row'>
                    <Button variant="primary" onClick={handleTradeClick} className=' mr-2'>
                        Trade
                    </Button>
                    <Button variant="success" onClick={addCustomAnnotation} className=' mr-2' >
                        Add Custom Annotation
                    </Button>
                    {/* Add the currency search button */}
                    <Button variant="warning" onClick={handleCurrencySearch} className=' mr-2'>
                        Search Currency
                    </Button>


                    <Select
                        className='mui-select'
                        id="account-select"
                        value={selectedAccount}
                        onChange={handleChange}
                        label="account-select"
                        slotProps={{
                            listbox: {
                                sx: {
                                    maxHeight: 300,
                                },
                            },
                        }}
                    >

                        {accounts?.map((account) => (
                            <Option key={account.id} value={account.id}>
                                {account.id}: {account.name}
                            </Option>
                        ))}

                    </Select>

                    <Link to="/dockview">
                        <Button variant="info" className="ml-2">
                            Dockview
                        </Button>
                    </Link>


                </div>

                <Modal show={showModalCurr} onHide={handleModalCloseCurr}>
                    <Modal.Header closeButton>
                        <Modal.Title>Search Currency</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            {/* Add currency search input */}
                            <Form.Group controlId="currencySearch">
                                <Form.Label>Search Currency</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Currency Symbol"
                                    value={selectedCurrency}
                                    onChange={(e) => setSelectedCurrency(e.target.value)}
                                />
                            </Form.Group>
                            {/* Display search results */}
                            {selectedCurrency.length > 0 ? currencySymbols
                                .filter((currency) =>
                                    currency.toLowerCase().includes(selectedCurrency.toLowerCase())
                                )
                                .map((currency, index) => (
                                    <div
                                        key={index}
                                        onClick={() => handleCurrencySelection(currency)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {currency}
                                    </div>
                                )
                                )
                                : ''
                            }
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleModalClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>


                <Modal show={showModal} onHide={handleModalClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Enter Stop Loss and Take Profit</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="stopLoss">
                                <Form.Label>Stop Loss</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Enter Stop Loss"
                                    value={stopLoss}
                                    onChange={(e) => setStopLoss(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group controlId="takeProfit">
                                <Form.Label>Take Profit</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Enter Take Profit"
                                    value={takeProfit}
                                    onChange={(e) => setTakeProfit(e.target.value)}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleModalClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handleSubmit}>
                            Submit
                        </Button>
                    </Modal.Footer>
                </Modal>

                <div id="container" />
            </div>
        </>
    );
};

export default Dashboard;














